// extracted by mini-css-extract-plugin
module.exports =  {"predictionBuilderForm":"predictionBuilderForm_Jc1TD5TS","formulaFormError":"formulaFormError_BxdO4fsC","formActions":"formActions_Ye89eeC1"};